// WMCE-455: Reduced muster initialization -- muster-lite initializing 359 variables
import muster from '@dbk-legacy/muster';
import musterHistory from '@dbk-legacy/muster/history';
import { ref } from '@dbk-legacy/muster/utils';
import roster from '@dbk-legacy/roster-client';
import rosterEbanking from '@dbk-legacy/roster-modules-ebanking/src/client';
import routeConfig from '../components/app/app.routes';
import rosterRoutes from './app/global/roster';

import i18n from './i18n';
import language from './language';
import extended from './@extended';
import screen from './screen';
import uiRoutes from './ui';
import deviceRoutes from './device';
import deviceInfoRoutes from './app/global/device-info';
import settings from '../data/get-settings';
import settingsRoutes from './settings';
import marque from './marque';

import authRoutes from './app/auth/auth.web';
import rsaRoutes from './app/rsa/rsa';
import vascoRoutes from './vascoauthentication';
import portfolioRoutes from './portfolio';
import portfoliosRoutes from './app/user/portfolios';
import eCredentials from './eCredentials';
import rmAccess from './rm-access';
import dataExports from './dataExports';

const INITIAL_PATH = '/webindex'; // webindex

export default (modelUrl) =>
  muster()
    .import('ui.history', musterHistory(INITIAL_PATH, settings.webfolder, { routeConfig }))
    .import(null, settingsRoutes())
    .import('roster', roster([
      rosterEbanking(settings.defaultEnvironment),
    ], modelUrl), {
      'rosterEbanking.env': ref('settings.currentEnvironment.id'),
    })
    .import('i18n', i18n())
    .import(null, language())
    .import(null, extended())
    .import(null, screen())
    .import(null, uiRoutes())
    .import(null, deviceRoutes())
    .import(null, deviceInfoRoutes())
    .import(null, marque())
    .import(null, authRoutes())
    .import(null, rsaRoutes())
    .import(null, vascoRoutes())
    .import(null, rosterRoutes())
    .import(null, portfolioRoutes())
    .import(null, portfoliosRoutes())
    .import(null, eCredentials())
    .import(null,rmAccess())
    .import(null, dataExports());



